/* eslint-disable react/style-prop-object */
import React, { useContext, useRef } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { Doughnut } from 'react-chartjs-2';
import { device } from 'helpers/screen';
import { Card, EmptyLabel } from 'components/CommonWidgets';
import { getStringColor } from 'helpers/strings';
import Skeleton from 'react-loading-skeleton';
import { DashboardContext } from 'context/DashboardContext';

const barOptions = {
	plugins: {
		title: {
			display: false,
			text: ''
		},
		legend: {
			position: 'right'
		}
	},
	responsive: false,
	maintainAspectRatio: false,
};

const getInputLabel = (item, isProductTab) => {
	if (isProductTab) {
		return item?.['food_item']?.name ?? '';
	} else {
		return item?.input?.name || item?.input || '-';
	}
};

const getChartData = (data, isProductTab) => {
	return {
		labels: data?.map((item) => getInputLabel(item, isProductTab)) ?? [],
		datasets: [
			{
				label: '# of Votes',
				data: data?.map((item) => item?.sum) ?? [],
				backgroundColor: data?.map(
					(item) => getStringColor(getInputLabel(item, isProductTab))
				) ?? [],
			}
		],
	};
};

const ChartWrapper = styled.div`
	position: relative;

	@media ${device.tablet} {
		padding: 5.1% 0 0 4%;
    	transform: scale(0.8);
	}
  	@media ${device.laptopSM} {
		padding: 5% 0 0 7%;
    	transform: scale(0.8);
	}
	@media ${device.laptop} {
		padding: 5% 0 0 7%;
    	transform: scale(1.1);
	}
	@media ${device.laptopL} {
		padding: 4% 0 0 10%;
		transform: scale(1.3);
	}
	@media (min-width: 1500px) {
		padding: 3.8% 0 0 14%;
		transform: scale(1.5);
	}
	@media (min-width: 1600px) {
		padding: 3.5% 0 0 16%;
		transform: scale(1.5);
	}
	@media (min-width: 1700px) {
		padding: 3.3% 0 0 18%;
		transform: scale(1.5);
	}
	@media ${device.desktop} {
		padding: 3% 0 0 21%;
		transform: scale(1.5);
	}
`;

const TotalChart = ({ data, tabName, isLoading = false }) => {
	const { currentTab } = useContext(DashboardContext);
	const chartRef = useRef();

	const isEmpty = () => data && !isLoading && data.length < 1;

	return (
		<Card cardHeight='18rem' mTop='1.9rem'>
			<div className="mb-2 text-end">نمودار کلی</div>
			{isLoading ? (<Skeleton count={1} height={220} />) : (
				isEmpty() ? (
					<EmptyLabel>
						رکوردی ثبت نشده است
					</EmptyLabel>
				) : (
					<ChartWrapper>
						<Doughnut
							data={getChartData(data, tabName === 'product')}
							options={barOptions}
							ref={chartRef}
						/>
					</ChartWrapper>
				)
			)}
		</Card>
	);
};

export default TotalChart;
